import { render } from "./VendorDetails.vue?vue&type=template&id=e6272acc&scoped=true"
import script from "./VendorDetails.vue?vue&type=script&lang=js"
export * from "./VendorDetails.vue?vue&type=script&lang=js"

import "./VendorDetails.vue?vue&type=style&index=0&id=e6272acc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6272acc"]])

export default __exports__